import React from 'react';
import { View } from 'react-native-web';

const Icon = () => {
  return (
    <View>

    </View>
  )
}

export default Icon;
